"use strict";
// tslint:disable
// eslint-disable
/**
 * Roles and Rights API
 * API for configurable roles and rights
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function SortedRightFromJSON(json) {
    return SortedRightFromJSONTyped(json, false);
}
exports.SortedRightFromJSON = SortedRightFromJSON;
function SortedRightFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'sortOrder': json['sortOrder'],
    };
}
exports.SortedRightFromJSONTyped = SortedRightFromJSONTyped;
function SortedRightToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'sortOrder': value.sortOrder,
    };
}
exports.SortedRightToJSON = SortedRightToJSON;
